const STORAGE_URL = (
  process.env.REACT_APP_STORAGE_URL || ""
).replace(/\/+$/, "");

const isAbsoluteUrl = (value) =>
  typeof value === "string" &&
  (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  );

export const buildStorageUrl = (fileName) => {
  if (!fileName) {
    return "";
  }

  if (isAbsoluteUrl(fileName)) {
    return fileName;
  }

  if (!STORAGE_URL) {
    console.warn(
      "La variable REACT_APP_STORAGE_URL n'est pas définie.",
    );

    return "";
  }

  return `${STORAGE_URL}/${fileName.replace(/^\/+/, "")}`;
};
